export interface ImageUrlOptions {
  background?: string;
  perspective?: string;
  imageType?: ImageType;
  crop?: number[];
  width?: number;
  height?: number;
  lights?: ImageUrlOptionsLights;
  rooftop?: ImageUrlOptionsRooftop;
  isCeImage?: boolean; // typically highly dynamical stage image
}

// if BCKGND=9 the Background will be transparent for PNG (P27/P4)
export const TRANSPARENT_STAGE_BCKGND = '9';

export enum ImageUrlOptionsLights {
  Day = 'SZT', // from german "Sonnenstand Tag"
  Night = 'SZN' // from german "Sonnenstand Nacht"
}

export enum ImageUrlOptionsRooftop {
  Opened = 'DZO', // from german "Dach offen"
  Closed = 'DZG' // from german "Dach geschlossen"
}

export enum BbdParameter {
  Imgt = 'IMGT',
  Bkgnd = 'BKGND',
  Pov = 'POV',
  Width = 'imwidth',
  Height = 'height',
  Crop = 'crop'
}

// P = PNG, A = JPG,
// 4 = 1000x295, 27 = 1920x1080
export enum ImageType {
  A27 = 'A27',
  P27 = 'P27',
  A4 = 'A4',
  P4 = 'P4'
}
